import { formatGericParsedDataConnectionResource } from "areas/verifications/helpers/generic-parsed-data";
import { Square } from "ui-kit/icon";
import { IIngestionSourceData } from './types';

const loginUrl = "https://app.squareup.com/dashboard/items/library"

const square: IIngestionSourceData = {
  displayName: "Square",
  isEcom: true,
  isAutomated: true,
  parsedDataFormatter: formatGericParsedDataConnectionResource,
  loginUrl,
  inventoryReminder: {
    buttonText: "OK, I will adjust my inventory",
    text: "Don't forget to adjust your Square inventory to reflect this Max Retail sale!",
    titleText: "Square Inventory Reminder",
    linkText: "Square Dashboard",
    linkHref: loginUrl
  },
  listInventory: {
    linkHref: loginUrl,
    icon: Square
  },
  cannotUpdateListing: {
    text: `To update this item, you need to edit it in your Square account.`,
    linkHref: loginUrl
  },
  listingsSubheader: {
    text: `You're connected to Square! While you can view your listings here, you can only make changes in your Max
        Retail collection via `,
    linkHref: loginUrl
  },
  errorReport: {
    getFixLinkHref: (productId: string) => `https://app.squareup.com/dashboard/items/library/${productId}`,
    listHref: "https://app.squareup.com/dashboard/items/library/new"
  }
};

export default square